module.exports = {
    content: [
		//'./**/*.php', // recursive search for *.php (be aware on every file change it will go even through /node_modules which can be slow, read doc)
		//'./src/styles/safelist.txt' // Use in case the inline "safelist" gets too long
		'./*.php',
		'./lib/**/*.php',
		'./templates/**/*.php',
		'./search-filter/**/*.php',
	],
	safelist: [
		{
			pattern: /bg-(purple|navy|blue|green|sage|yellow|orange|red|beige|clay)/,
		},
		'after:bg-purple', 'after:bg-navy', 'after:bg-blue',
		'after:bg-green', 'after:bg-sage', 'after:bg-yellow',
		'after:bg-orange', 'after:bg-red', 'after:bg-beige', 'after:bg-clay',
		{
			pattern: /fill-(purple|navy|blue|green|sage|yellow|orange|red|beige|clay)/,
		},
		{
			pattern: /stroke-(purple|navy|blue|green|sage|yellow|orange|red|beige|clay)/,
		},
		//{
			//pattern: /text-(white|black)-(200|500|800)/
		//}
	],
    theme: {
        colors: {
            'transparent': 'transparent',
            'white': '#FFF',
            'black': '#000',
            'purple': '#33142A',
            'navy': '#0B3F62',
			'navy-darker': '#093857',
            'blue': '#ADD6E1',
            'blue-darker': '#A1C8D2',
            'green': '#2A4024',
            'sage': '#5A6A4E',
            'yellow': '#ECC955',
            'orange': '#F59042',
            'red': '#D73316',
            'red-darker': '#A91A0E',
            'beige': '#CFB188',
            'clay': '#F3EEE8',
        },
        fontFamily: {
            sansdm: ["dm-sans-regular", "sans-serif"],
            sansdmmedium: ["dm-sans-medium", "sans-serif"],
            sansdmbold: ["dm-sans-bold", "sans-serif"],
            domaine: ["domaine-display-regular", "sans-serif"],
        },
		spacing: {
			0: "0px",
			1: "1px",
			2: "2px",
			3: "3px",
			4: "4px",
			5: "5px",
			6: "6px",
			7: "7px",
			8: "8px",
			9: "9px",
			10: "10px",
			11: "11px",
			12: "12px",
			13: "13px",
			14: "14px",
			15: "15px",
			16: "16px",
			17: "17px",
			18: "18px",
			19: "19px",
			20: "20px",
			24: "24px",
			25: "25px",
			28: "28px",
			30: "30px",
			35: "35px",
			40: "40px",
			45: "45px",
			50: "50px",
			55: "55px",
			60: "60px",
			65: "65px",
			70: "70px",
			75: "75px",
			80: "80px",
			85: "85px",
			90: "90px",
			95: "95px",
			100: "100px",
			105: "105px",
			110: "110px",
			115: "115px",
			120: "120px",
			125: "125px",
			130: "130px",
			135: "135px",
			140: "140px",
			145: "145px",
			150: "150px",
			160: "160px",
			170: "170px",
			180: "180px",
			190: "190px",
			200: "200px",
			210: "210px",
			220: "220px",
			230: "230px",
			240: "240px",
			250: "250px",
			300: "300px",
			350: "350px",
			400: "400px",
			500: "500px",
		},
        container: {
            center: true,
			padding: {
				// Need to assign all of the screen sizes or the container-break-out plugin won't work
				DEFAULT: "30px",
				xs: "30px",
				sm: "30px",
				md: "30px",
				lg: "30px",
				xl: "30px",
				"2xl": "30px",
			},
            screens: {
				xs: '340px',
				sm: '576px',
				md: '768px',
				lg: '992px',
				xl: '1280px',
				'2xl': '1536px',
            }
        },
		screens: {
			xs: '340px',
            sm: '576px',
            md: '768px',
            lg: '992px',
            xl: '1280px',
            '2xl': '1536px',
		},
        extend: {
			container: {
				screens: {
					xs: {
						max: 'none', // Remove the max-width: 340px from the xs breakpoint
					},
				},
			},
			debugScreens: {
				position: ['top', 'right'],
			},
            borderRadius: {
                DEFAULT: '5px',
                'full': '9999px',
            },
            borderWidth: {
                DEFAULT: '1px',
            },
            aspectRatio: {
                '16/9': '16 / 9',
                '16/11': '16 / 11',
                '20/9': '20 / 9',
                '5/3': '5 / 3',
                '4/3': '4 / 3',
                '4/5': '4 / 5',
                '4/6': '4 / 6',
                '3/1': '3 / 1',
            },
        }
    },
    plugins: [
        function ({ addVariant }) {
            addVariant("children", "& > *");
            addVariant("children-all", "& *");
            //addVariant("next-peer-hover", ".peer:hover + &");
            //addVariant("item-active", "&[data-active=true]");
            //addVariant("item-active-children", "&[data-active=true] > *");
        },
		require('@tailwindcss/forms'),
		require('tailwindcss-debug-screens'),
		require('tailwind-container-break-out')
    ],
}